import React from 'react';
import { Icon } from '../../../SvgIcon';

interface Props {
  width?: number;
  height?: number;
}

export const AppMeituan = (props: Props) => {
  const { width = 20, height = 20 } = props;
  return <Icon name="meituanApp" width={width} height={height} />;
};
